import { useMemo } from 'react';
import { CvShareSheet } from './CvShareSheet.web';
import { downloadCvExport, type ExportFormat } from '../../lib/cv-export';
import type { CvVisibilityOptions } from './CVSharePanel';
import { useCVData } from '../../lib/cv-mock-data';
import { getCvShareVisibilityDefaults } from '../../lib/cv-privacy';

interface ShareDialogProps {
  url?: string | null;
  profileName: string;
  accentColor?: string;
  onClose: () => void;
}

export function ShareDialog({ url, onClose }: ShareDialogProps) {
  const { target, privacy } = useCVData();
  const visibility = useMemo(
    () => getCvShareVisibilityDefaults(privacy),
    [privacy],
  );

  const onDownload = async (
    format: ExportFormat,
    options?: { visibility?: CvVisibilityOptions; variantId?: string | null },
  ) => {
    await downloadCvExport(format, {
      target,
      variantId: options?.variantId,
      visibility: options?.visibility ?? visibility,
    });
  };

  return <CvShareSheet publicUrl={url} onClose={onClose} onDownload={onDownload} />;
}
